export const hiddenMessageAPI = ["user-preferences-general"];
